// src/components/loader/loader.js
import React from 'react';
import './fireParticles.css';
import logo from './loader-logo.png';

const Loader = () => {
  return (
    <div className="loader-container">
      <img src={logo} alt="Rebel Fox Logo" className="rotating-logo" />
      <div className="particles-container">
      {[...Array(80)].map((_, i) => {
const left = Math.random() * 60 + 20;
const delay = Math.random() * 3;
  const size = Math.random() * 4 + 4;

  return (
    <div
      key={i}
      className="particle"
      style={{
        left: `${left}%`,
        bottom: `0`, // <-- Asegura que empiece desde abajo
        animationDelay: `${delay}s`,
        width: `${size}px`,
        height: `${size}px`,
      }}
    />
  );
})}
      </div>
    </div>
  );
};

export default Loader;
